import { render, staticRenderFns } from "./ResearchRegionTrackVector.vue?vue&type=template&id=5dd92232&"
import script from "./ResearchRegionTrackVector.vue?vue&type=script&lang=js&"
export * from "./ResearchRegionTrackVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd92232')) {
      api.createRecord('5dd92232', component.options)
    } else {
      api.reload('5dd92232', component.options)
    }
    module.hot.accept("./ResearchRegionTrackVector.vue?vue&type=template&id=5dd92232&", function () {
      api.rerender('5dd92232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/vectorPlots/ResearchRegionTrackVector.vue"
export default component.exports